var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBAppInDesign({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2648 0H9.73519C4.35859 0 0 4.35859 0 9.73519V44.2648C0 49.6414 4.35859 54 9.73519 54H44.2648C49.6414 54 54 49.6414 54 44.2648V9.73519C54 4.35859 49.6414 0 44.2648 0Z",
    fill: "#49021F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9395 14.4255H19.8223V39.2173H12.9395V14.4255Z",
    fill: "#FF3366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4482 29.6707C22.4482 22.936 27.4805 19.5688 32.6982 19.5688C33.4014 19.5688 34.1411 19.6428 34.585 19.717V13.6484H41.0606V37.9592C39.5068 38.7363 36.4356 39.5503 33.105 39.5503C27.4067 39.5503 22.4482 36.3311 22.4482 29.6707ZM34.585 34.148V25.0823C34.1411 24.9343 33.5859 24.8233 32.8457 24.8233C30.8105 24.8233 28.9238 26.0073 28.9238 29.5596C28.9238 32.8159 30.626 34.2959 32.8828 34.2959C33.4014 34.2959 34.104 34.259 34.585 34.148Z",
    fill: "#FF3366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBAppInDesign);
export default __webpack_public_path__ + "static/media/B_app_InDesign.400477f11fa4b0fec42a1a46e80a12ea.svg";
export { ForwardRef as ReactComponent };